import informationIcon from '../../images/icons/information-icon.png';
import Tooltip from "../common/Tooltip";
import { useContext, useEffect, useMemo, useState } from "react";
import { db } from "../../firebase/config";
import QuestionMeta from "../dashboard/QuestionMeta";
import LiveReportRenderContext from "../../StateManagment/LiveReportRenderContext";
import { useFirestoreNoCompagny } from "../../firebase/useFirestore";
import WeeklyResultsChart from '../common/WeeklyResultsChart';
import Modal from '../common/Modal';
import Location from '../../hooks/Location';
import LineChartIcon from '@mui/icons-material/SsidChartOutlined';
import PieChartIcon from '@mui/icons-material/PieChartOutlineOutlined';
import BarChartIcon from '@mui/icons-material/BarChartOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import DataType from '../graphData/DataType';
import useSettings from '../../hooks/Settings';
import useChartColors from '../../hooks/useChartColors';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import CardHeaderInfoPopover from '../common/CardHeaderInfoPopover';
import ProjectsBreakdownSection from '../common/ProjectsBreakdownSection';
import useHierarchyData from '../../hooks/useHierarchyData';
import defaultDates from '../../utils/defaultDates';
import toMillis from '../../helpers/dataHelpers/matrixDataHelpers/toMillis';
import TemplateIndicatorChart from '../liveReport/reportBuilder2/widgets/templateRenderers/TemplateIndicatorChart';
import summarizeRespondentsByMoment from '../../helpers/dataHelpers/summarizeRespondentsByMoment';
import momentTitlesForRecords from '../../helpers/dataHelpers/momentTitlesForRecords';
import ResponsesSummarySection from '../common/ResponsesSummarySection';

const IndicatorData = ({
    effectId,
    indicator,
    startDate,
    endDate,
    docid,
    graphType,
    personaId,
    paragrapgMomentVisibilityStyle,
    fieldType,
    liveReportHidden,
    graphColor = {},
    actions,
    colorPalette,
    colorOverrides,
    scaleColors,
    dashboardOptions,
    templateData,
    onCompareData }) => {

    const inLiveReport = useContext(LiveReportRenderContext);

    // Buiten een live rapportage komt de kleur uit het vaste palet, dus de
    // primaire kaartkleur die hier ooit gekozen is telt niet meer mee.
    const { overrides } = useChartColors({ colorPalette, colorOverrides });

    // State
    const [title, setTitle] = useState('');
    const [researchId, setResearchId] = useState('');
    const [numberOfMeasureMoments, setNumberOfMeasureMoments] = useState('');
    const [type, setType] = useState('');
    const [momentId, setMomentId] = useState('');
    const [showResponsesVisibilityOptions, setShowResponsesVisibilityOptions] = useState(false)
      const [modalGraphTypeOpen, setModalGraphTypeOpen] = useState(false)
    const [projectBreakdown, setProjectBreakdown] = useState(/** @type {Object<string, string> | null} */ (null));

    // Reset per-project averages when the indicator changes — only Scale/Number
    // children repopulate this via onProjectBreakdownChange, so without a reset
    // a Multiple/Open indicator would inherit the previous indicator's averages.
    useEffect(() => {
        setProjectBreakdown(null);
    }, [indicator?.ID]);

    // Hooks
    const currentPage = Location()[2];
    const portfolio = useSettings().portfolio;

    // Firestore
    const research = useFirestoreNoCompagny('Research', 'QuestionnaireID', indicator.QuestionnaireID ? indicator.QuestionnaireID : '123');
    const measureMomentsRaw = useFirestoreNoCompagny('MeasureMoments', 'ResearchID', researchId ? researchId : '');
    const measureMoments = useMemo(() => (measureMomentsRaw || []).filter((m) => !m.Deleted), [measureMomentsRaw]);
    const questionnaires = useFirestoreNoCompagny('Questionnaires', 'ID', indicator.QuestionnaireID ? indicator.QuestionnaireID : '');

    const meetmomentLabel = measureMoments && measureMoments.length === 1
        ? (measureMoments[0].Title || '—')
        : (measureMoments && measureMoments.length > 1
            ? `${measureMoments.length} meetmomenten`
            : '—');
    const questionnaireTitle = (questionnaires && questionnaires[0] && questionnaires[0].Title) || '—';
    const researchTitle = title || '—';
    const hasResearch = researchTitle !== '—';

    // Get research id and title
    useEffect(() => {
        research && research.map(doc => {
            setResearchId(doc.ID);
            setTitle(doc.Title);
        });
    }, [research]);

    // Get number of measure moments
    useEffect(() => {
        if (measureMoments) {
            setNumberOfMeasureMoments(measureMoments.length);
        }
    }, [measureMoments]);

    // Get type of moment
    useEffect(() => {
        if (numberOfMeasureMoments === 1) {
            setType(`${indicator.Type}-moment`);
            setMomentId(measureMoments[0].ID);
        } else if (numberOfMeasureMoments > 1) {
            setType(`${indicator.Type}-development`);
        } else {
            setType('output');
        }
    }, [numberOfMeasureMoments]);

    // Function to update indicator visibility
    const updateIndicatorVisibility = async (e) => {
        const type = e.currentTarget.dataset.type;
        await db.collection('QuestionnaireFields')
            .doc(docid)
            .update({
                LiveReportHidden: type === 'on' ? false : true
            });
    };

    // Function to select graph type
    const selectGraphType = async (e) => {
        const type = e.target.dataset.type;
        await db.collection('QuestionnaireFields')
            .doc(docid)
            .update({
                GraphType: type
            });

        setModalGraphTypeOpen(false)
    };

    // Function to select visibility of graph or text or both for paragraph-moment questions
    const selectTextOrGraphVisibility = async (e) => {

        const selectedOption = e.currentTarget.dataset.option 

        await db.collection('QuestionnaireFields')
        .doc(docid)
        .update({
            ParagraphMomentVisibilityStyle: selectedOption 
        })

    }


    // Tooltip content
    const tooltipContent = () => {
        const typeSetting = () => {
            if (measureMoments.length === 1) {
                return 'Momentopname';
            } else if (measureMoments.length > 1) {
                return 'Ontwikkeling';
            } else {
                return 'Outputresultaat';
            }
        };

        return (
            <div className="home-kpi-tooltip-container">
                <p><b>Onderzoek</b></p>
                <p>{title}</p>
                <p><b>Type</b></p>
                <p>{typeSetting()}</p>
                {/* <p><b>Periode</b></p> */}
                {/* <p>{startDate ? `Start: ${startDate.toDate().toLocaleDateString()}` : 'Alles'}</p>
                <p>{endDate ? `Eind: ${endDate.toDate().toLocaleDateString()}` : 'Alles'}</p>                 */}
            </div>
        );
    };

    // MSI matrix detection — selects the hierarchy syncType for the breakdown.
    const isMsiMatrix = (indicator.Type === 'matrix-one' || indicator.Type === 'matrix-multiple')
        && indicator.Standard === 'true';

    // Mirror the chart components' fetch (same params → cache hit, no extra
    // Cloud Function call) so the popover sees the same records — enriched with
    // MomentPosition — on every tenant. The per-project breakdown still renders
    // portfolio-only (it returns null elsewhere), but the per-moment
    // respondents/answers need these records on project tenants too.
    const { defaultStartDate: popoverDsRaw, defaultEndDate: popoverDeRaw } = useMemo(() => defaultDates(), []);
    const popoverDsMs = useMemo(() => toMillis(popoverDsRaw) ?? 0, [popoverDsRaw]);
    const popoverDeMs = useMemo(() => toMillis(popoverDeRaw) ?? 8640000000000000, [popoverDeRaw]);
    const popoverStartMs = useMemo(() => toMillis(startDate) ?? popoverDsMs, [startDate, popoverDsMs]);
    const popoverEndMs = useMemo(() => toMillis(endDate) ?? popoverDeMs, [endDate, popoverDeMs]);
    const {
        records: popoverRecords,
        respondentsPerProject: popoverRespondents,
        loading: popoverLoading,
        error: popoverError,
    } = useHierarchyData({
        syncType: isMsiMatrix ? 'MSIEffect' : 'Question',
        id: indicator.ID,
        startDate: popoverStartMs,
        endDate: popoverEndMs,
        researchIds: researchId ? [researchId] : [],
        personaId,
    });

    // Position → title / id → position maps for the per-moment breakdown.
    const { id2pos, pos2title } = useMemo(() => {
        const id2posMap = {};
        const pos2titleMap = {};
        (Array.isArray(measureMoments) ? measureMoments : []).forEach((m) => {
            const pos = typeof m?.Position === 'number' ? m.Position : parseInt(m?.Position, 10);
            if (Number.isNaN(pos)) return;
            id2posMap[m.ID] = pos;
            if (m?.Title && pos2titleMap[pos] === undefined) pos2titleMap[pos] = m.Title;
        });
        // Meerdere onderzoeken → alleen posities; zie momentTitlesForRecords.
        return { id2pos: id2posMap, pos2title: momentTitlesForRecords(pos2titleMap, popoverRecords) };
    }, [measureMoments, popoverRecords]);

    // Respondents + answers (per moment when >1) from the hierarchy records
    // (includes synced child projects on portfolio tenants).
    const responseSummary = useMemo(
        () => summarizeRespondentsByMoment(popoverRecords, { id2pos, pos2title }),
        [popoverRecords, id2pos, pos2title]
    );

    const popoverContent = (
        <div>
            <div className="info-popover-row">
                <span className="info-popover-row-label">Onderzoek</span>
                <span className="info-popover-row-value">{researchTitle}</span>
            </div>
            <div className="info-popover-row">
                <span className="info-popover-row-label">Meetmoment</span>
                <span className="info-popover-row-value">{meetmomentLabel}</span>
            </div>
            {hasResearch && (
                <div className="info-popover-row">
                    <span className="info-popover-row-label">Vragenlijst</span>
                    <span className="info-popover-row-value">{questionnaireTitle}</span>
                </div>
            )}
            <ResponsesSummarySection
                respondents={responseSummary.totalRespondents}
                answers={responseSummary.totalAnswers}
                perMoment={responseSummary.perMoment}
                loading={popoverLoading}
                error={popoverError}
            />
            <WeeklyResultsChart
                records={popoverRecords}
                title="Antwoorden per week"
                dedupeKey="FormID"
            />
            {projectBreakdown
                ? <ProjectsBreakdownSection values={projectBreakdown} valueLabel="Gemiddelde" average />
                : <ProjectsBreakdownSection values={popoverRespondents} valueLabel="Antwoorden" />}
        </div>
    );

    return (
        <div className="home-kpi-chart-container">
            {!inLiveReport && (
            <div className="home-kpi-description-container">
                <div className='home-kpi-question-title-container'>
                    {templateData
                        ? (indicator.Standard !== 'true' && indicator.Question && (
                            <p style={{ color: graphColor?.[indicator.ID] || 'black' }}>{indicator.Question}</p>
                        ))
                        : <QuestionMeta field={indicator.ID} color={graphColor?.[indicator.ID] || "gray"} />
                    }
                    {!templateData && (
                        <CardHeaderInfoPopover label="Details" content={popoverContent} />
                    )}
                    {actions && <div className='event-data-actions'>{actions}</div>}
                </div>
              
                {/* <p>{indicator.Title}</p> */}

                {/* <div>
                    {portfolio === 'block' &&
                        <Tooltip content={'Project details'} width={'50px'} top='30px'>
                            <StorefrontOutlinedIcon />
                        </Tooltip>
                    }
                    <Tooltip content={tooltipContent()} width={'50px'} top='30px' left='-100px'>
                        <img src={informationIcon} alt="" />
                    </Tooltip>
                </div> */}

            </div>
            )}

            {templateData ? (
                <TemplateIndicatorChart
                    fieldId={indicator.ID}
                    templateData={templateData}
                    graphType={graphType}
                    colorPalette={colorPalette}
                />
            ) : (
                <DataType
                    effectId={effectId}
                    type={indicator.Type}
                    fieldId={indicator.ID}
                    startDate={startDate}
                    endDate={endDate}
                    researchId={researchId}
                    graphType={graphType}
                    paragrapgMomentVisibilityStyle={paragrapgMomentVisibilityStyle}
                    projectId={indicator.CompagnyID}
                    personaId={personaId}
                    colorPalette={colorPalette}
                    colorOverrides={colorOverrides}
                    scaleColors={scaleColors}
                    primaryColorOverride={overrides?.primary}
                    onProjectBreakdownChange={setProjectBreakdown}
                    onCompareData={onCompareData}
                />
            )}

            {dashboardOptions}

            {/* Chart options container */}
            {/* <div id='chart-options-container'
            style={{
                display:
                     currentPage === 'printlivereport' || currentPage === 'livereportopen'
                    ? 'none'
                    : 'flex',
                }}
            > */}
            {/* Field visible in live report toggle */}
            {/* <div>
            {liveReportHidden ? 
                <Tooltip content={'Niet zichtbaarheid in live rapportage'} width={'50px'} top='30px'>
                    <VisibilityOffOutlinedIcon 
                    data-type={'on'} 
                    onClick={updateIndicatorVisibility}        
                    />
                </Tooltip>
            :
                <Tooltip content={'Zichtbaarheid in live rapportage'} width={'50px'} top='30px'>
                    <VisibilityOutlinedIcon
                    data-type={'off'} 
                    onClick={updateIndicatorVisibility}
                    />
                </Tooltip>
            }
            </div> */}


            {/* Update graphtype */}
            {/* <div>
                <Tooltip content={'Grafiektype aanpassen'} width={'50px'} top='30px'>
                        {
                            graphType === 'bar' ? (
                                <BarChartIcon onClick={() => setModalGraphTypeOpen(true)} />
                            ) : graphType === 'line' ? (
                                <LineChartIcon onClick={() => setModalGraphTypeOpen(true)} />
                            ) : graphType === 'pie' ? (
                                <PieChartIcon onClick={() => setModalGraphTypeOpen(true)} />
                            ) : graphType === undefined ? (
                                <BarChartIcon onClick={() => setModalGraphTypeOpen(true)} />
                            ) : null
                        }
                </Tooltip>
            </div> */}

            {/* Paragraph-moment visibility style toggle */}
            {/* <div
            id='parargraph-moment-visibility-style-option-container'
            style={{
                display: type === 'paragraph-moment'
                        ? 'flex' 
                        : 'none'
                }}
            >
                <Tooltip content={'Responses zichtbaarheid aanpassen'} width={'50px'} top='30px'>
                    <ChatOutlinedIcon onClick={() => setShowResponsesVisibilityOptions(!showResponsesVisibilityOptions)}/>
                </Tooltip>
                <div className='add-options-container live-report-graph-options-container' style={{display: showResponsesVisibilityOptions ? 'flex' : 'none'}} onMouseLeave={() => setShowResponsesVisibilityOptions(!showResponsesVisibilityOptions)}>
                   <p style={{color: paragrapgMomentVisibilityStyle === 'both' ? 'green' : 'black'}} data-option={'both'} onClick={selectTextOrGraphVisibility}>Reponses + grafiek</p>
                    <p style={{color: paragrapgMomentVisibilityStyle === 'text' ? 'green' : 'black'}} data-option={'text'} onClick={selectTextOrGraphVisibility}>Alleen reponses</p>
                    <p style={{color: paragrapgMomentVisibilityStyle === 'graph' ? 'green' : 'black'}} data-option={'graph'} onClick={selectTextOrGraphVisibility}>Alleen grafiek</p>
                </div>
            </div>
        </div> */}

        <Modal
        modalOpen={modalGraphTypeOpen}
        setModalOpen={setModalGraphTypeOpen}
        pageHeader="Grafiektype aanpassen"
        hideConfirm
        cancelLabel="Klaar"
        content={
            <div>
                <div className='update-graph-type-container'>
                    <input type="radio" defaultChecked={graphType === 'bar'} data-type={'bar'} name='barchart' onClick={selectGraphType}/>
                    <BarChartIcon />
                    <p>Staafdiagram</p>
                </div>
                <div className='update-graph-type-container'>
                    <input type="radio" defaultChecked={graphType === 'line'} name='barchart' data-type={'line'} onClick={selectGraphType}/>
                    <LineChartIcon />
                    <p>Lijngrafiek</p>
                </div>
                <div className='update-graph-type-container'>
                    <input type="radio" defaultChecked={graphType === 'pie'} name='barchart' data-type={'pie'} onClick={selectGraphType}/>
                    <PieChartIcon />
                    <p>Taartdiagram</p>
                </div>
            </div>
        }
        />
        </div>
    );
};

export default IndicatorData;
